theme.announcementBar = () => {
  let announcementEle = document.querySelector('.announcebar-wrapper'),
      swiperOptions = JSON.parse(announcementEle.dataset.sliderOptions);
      swiper = new Swiper(announcementEle,swiperOptions);

      announcementEle.addEventListener('mouseover', () => {
        swiper.autoplay.stop();
      })
      announcementEle.addEventListener('mouseleave', () => {
        swiper.autoplay.start();
      })
      

      // pause annoucement bar on block select
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          let targetEle = e.target,
              sliderIndex = 1 + parseInt(targetEle.dataset.swiperSlideIndex);
              swiper.slideTo(sliderIndex);
              swiper.autoplay.stop();
        })
        const customizationEvents = ['shopify:inspector:activate','shopify:inspector:deactivate','shopify:section:load','shopify:block:deselect','shopify:section:reorder','shopify:section:select','shopify:section:deselect','shopify:inspector:activate','shopify:inspector:deactivate'];

        customizationEvents.forEach(event => {
          document.addEventListener(event, () => swiper.init(swiperOptions));  
        })
      }
} 

window.addEventListener('DOMContentLoaded', () => {
  theme.announcementBar();
})